import { CustomValidators } from 'shared/validation/custom-validators';
import { countryLookup } from 'utils/lookups';

/* eslint-disable */
export const teamSegmentData: any = [
  {
    // "item_name": "ZZZ-AVATAR",
    "field_map": "initials",
    "item_name": "initials",
    "title": "",
    "hint_detail": "Initials",
    "hint_panel" : "Initials",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
  {
    // "item_name": "ZZZ-NAME",
    "field_map": "name",
    "item_name": "name",
    "title": "Name",
    "hint_detail": "Name",
    "hint_panel" : "Name",
    "example": "",
    "sequence": 2,
    "show_more": true,
    "lookup": null,
  },
  {
    // "item_name": "ZZZ-EMAIL",
    "field_map": "email",
    "item_name": "email",
    "title": "Email address",
    "hint_detail": "Email address",
    "hint_panel" : "Email address",
    "example": "",
    "sequence": 3,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PROFILE_VALIDATION': {
        maxLength: 254,
        validator: CustomValidators.email,
        message: 'A valid email must be provided and may not be longer than 254 characters'
      },
    },
  },
  {
    // "item_name": "ZZZ-PHONE",
    "field_map": "phone",
    "item_name": "phone",
    "title": "Phone",
    "hint_detail": "Phone",
    "hint_panel" : "Phone",
    "example": "",
    "sequence": 4,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PROFILE_VALIDATION': {
        validator: CustomValidators.digits,
        message: 'Phone cannot have Alphabetical characters.'
      },
    }
  },
  {
    // "item_name": "ZZZ-LAST",
    "field_map": "lastAccessed",
    "item_name": "last_accessed",
    "title": "Last accessed",
    "hint_detail": "Last accessed",
    "hint_panel" : "Last accessed",
    "example": "",
    "sequence": 5,
    "show_more": true,
    "lookup": null
  },
]
/* eslint-enable */
